import { autoinject, LogManager } from 'aurelia-framework';
import { DialogService } from 'aurelia-dialog';
import { NotificationInfoService } from "data/service/notification-info-service";
import { NotificationInfo } from "data/entities/notification-info";
import { Subscription, EventAggregator } from 'aurelia-event-aggregator';
import { AppEvents } from 'core/app-events';
import { AppUserInfoService } from '../../data/service/app-user-info-service';
import { AppUserInfo } from '../../data/entities/entities';
import { Prompt } from '../../shared/components/prompt/prompt';

@autoinject()
export class Notifications {
	notificationCountSubscription: Subscription;
	currentNotificationOptionId: any;
	appUserInfo: AppUserInfo;
	logger = LogManager.getLogger('Notifications');
	items: Array<NotificationInfo> = [];
	showEmptyMessage = true;
	eventSubscriptions: Array<Subscription> = [];
	notificationCount = 0;
	constructor(private notificationInfoService: NotificationInfoService,
		private dialogService: DialogService,
		private appUserInfoService: AppUserInfoService,
		private eventAggregator: EventAggregator
	) {
		
	}

	async deactivate() {
		this.unsubscribeFromEvents();
	}

	private unsubscribeFromEvents() {
		for (const entry of this.eventSubscriptions) {
			entry.dispose();
		}
		this.eventSubscriptions = [];
	}

	async activate() {
		this.subscribeToEvents();
		this.appUserInfo = await this.appUserInfoService.getCurrentAppUserInfo();
		this.getNotifications();
	}

	subscribeToEvents() {
		this.eventSubscriptions._add(this.eventAggregator.subscribe(AppEvents.DIRECTORY_CHANGED, payload => {
			this.onDirectoryChanged(payload);
		}));
		this.eventSubscriptions._add(this.eventAggregator.subscribe(AppEvents.NOTIFICATION_COUNT_CHANGED, message => {
			this.notificationCount = message;
		}));
	}

	onDirectoryChanged(payload) {
		this.logger.info('OnDirectoryChanged');
		this.logger.info('this.items.length = ' + this.items.length);
		this.getNotifications();
	}

	async restoreNotifications(numberToRestore: number) {
		try {
			await this.notificationInfoService.restoreNotifications(numberToRestore);
			this.activate();
		}
		catch (error) {
			this.logger.error(error);
		}
	}

	refresh() {
		this.getNotifications();
	}

	private async getNotifications() {
		this.eventAggregator.publish(AppEvents.ToggleIsBusyVisiblity, true);
		try {
			this.showEmptyMessage = false;
			this.notificationInfoService.getNotificationCount();
			this.items = [];
			const items: [] = await this.notificationInfoService.getNotifications();
			if (this.appUserInfo) {
				items.forEach((item: NotificationInfo) => {
					item.showDetails = this.appUserInfo.isExpandNotificationPanel;
					this.items._add(item)
				});
			}
			this.showEmptyMessage = true;
		}
		catch (error) {
			this.logger.error(error);
		}
		this.eventAggregator.publish(AppEvents.ToggleIsBusyVisiblity, false);
	}

	async markAllAsRead() {
		if (this.items) {
			const first = this.items[0].id;
			const last = this.items[this.items.length - 1].id;

			try {
				await this.notificationInfoService.markAllAsRead(first, last);
				this.items.length = 0;
				this.activate();
			}
			catch (error) {
				this.logger.error(error);
			}
		}
	}

	async clearAllNotification() {
		if (this.items) {
			try {
				const options = { message: `Are sure you want to close all ${this.notificationCount} notification?`, title: "Confirm", okButtonText: "Yes", cancelButtonText: "No" };
				this.dialogService.open({ viewModel: Prompt, model: options }).whenClosed(async response => {
					if (!response.wasCancelled) {
						await this.notificationInfoService.clearAllAsRead();
						this.items.length = 0;
						this.activate();
					}
				});
			}
			catch (error) {
				this.logger.error(error);
			}
		}
	}

	markAsRead(notification: NotificationInfo) {
		this.notificationInfoService.markAsRead(notification.id);
		if (notification.children) {
			for (const child of notification.children) {
				this.notificationInfoService.markAsRead(child.id);
			} 
		}
		this.items._remove(notification);
	}
}